import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'base',
      'loginUser',
      'services',
      'teams',
      'selectedMember',
    ]),
  },
  methods: {
    checkLoginUserPermission(actions, currentTeamId) {
      const permission = this.loginUser.permission;
      const serviceId = this.base.service;
      const UserPermission = this.loginUser.permission[serviceId];
      const hasService = {}.hasOwnProperty.call(permission, serviceId);
      let isPermission = false;

      if (!this.selectedMember) return isPermission;
      if (hasService) {
        actions.forEach((action) => {
          if (action === 'request') {
            Object.keys(this.loginUser.team).forEach((teamId) => {
              const hasTeam = currentTeamId ?
                Object.keys(this.loginUser.team).includes(currentTeamId) :
                {}.hasOwnProperty.call(this.selectedMember.affiliatedTeams, teamId);
              const hasAction = this.loginUser.team[teamId].exception.indexOf(`${serviceId}-${serviceId}-${action}`) > -1;

              if (hasAction && hasTeam) {
                isPermission = true;
              }
            });
          } else if (action === 'admin_service') {
            if (currentTeamId) {
              const affiliatedTeam = this.selectedMember.affiliatedTeams[currentTeamId];

              if ({}.hasOwnProperty.call(affiliatedTeam, 'agreements') && affiliatedTeam.agreements.length) {
                affiliatedTeam.agreements.forEach((agreement) => {
                  const hasAction = UserPermission.includes(agreement.admin);

                  if (hasAction && agreement.agree === null) {
                    isPermission = true;
                  }
                });
              }
            } else {
              Object.keys(this.selectedMember.affiliatedTeams).forEach((affiliatedTeamId) => {
                this.selectedMember.affiliatedTeams[affiliatedTeamId].agreements.forEach((agreement) => {
                  if (UserPermission.includes(agreement.admin)) {
                    isPermission = true;
                  }
                });
              });
            }
          } else if (action === 'admin_authority') {
            if (currentTeamId) {
              const affiliatedTeam = this.selectedMember.affiliatedTeams[currentTeamId];

              if ({}.hasOwnProperty.call(affiliatedTeam, 'agreements') && !affiliatedTeam.agreements.length) {
                if (UserPermission.includes(action)) {
                  isPermission = true;
                }
              }
            } else {
              Object.keys(this.selectedMember.affiliatedTeams).forEach((affiliatedTeamId) => {
                const affiliatedTeam = this.selectedMember.affiliatedTeams[affiliatedTeamId];

                if (!affiliatedTeam.agreements.length) {
                  if (UserPermission.includes(action)) {
                    isPermission = true;
                  }
                }
              });
            }
          } else if ({}.hasOwnProperty.call(permission[serviceId], action)) {
            isPermission = true;
          }
        });
      }
      return isPermission;
    },
  },
};




// WEBPACK FOOTER //
// ./src/mixins/checkLoginUserPermission.js